import type { IconSvgObject } from './types';

const ShopSignIcon: IconSvgObject = [
  ["path", { d: "M3.5 15.5H10.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 21.5L7 2.5M7 2.5L12 21.5H22L18 2.5H7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ShopSignIcon;
